<template>
  <div class="enterprise-page">
    <EnterpriseIntro />
    <EnterpriseInfo />
    <HeroMazipano />
    <EnterpriseContact />
  </div>
</template>

<script setup>
import EnterpriseIntro from "./EnterpriseIntro.vue";
import EnterpriseInfo from "./EnterpriseInfo.vue";
import HeroMazipano from "./HeroMazipano.vue";
import EnterpriseContact from "./EnterpriseContact.vue";
</script>

<style lang="scss" scoped>
.enterprise-page {
  background: #000;
  color: white;
  font-family: "Book21", "Sharp Grotesk", sans-serif;
}
</style>
